export default {
    lang: "马来语",
    application: {
        name: 'Sistem Penerbitan Maklumat',
    },
    ajaxTip: {
        success: 'Berjaya',
        error: 'Gagal',
        noAccess: 'Tiada kebenaran mengakses sumber daya ini',
        notFound: 'Sumber daya yang diakses tidak wujud',
        serverBusy: 'Server sibuk',
        timeOut: 'Waktu tamat',
    },
    menu: {
        home: 'Laman Utama',
        template: 'Pengurusan Templat',
        program: 'Pengurusan Program',
        playplan: 'Rancangan Permainan',
        device: 'Pengurusan Peranti',
        "source-material": 'Pengurusan Bahan Sumber',
        material: 'Bahan',
        checkManage: 'Pengurusan Semakan',
        setting: 'Tetapan',
        usercenter: "Pusat Pengguna",
        adminManage: "Pengurusan Peranti",
        schedule: "Tugas Yang Perlu Dilakukan",
        capitalassets: "Pengurusan Aset",
        modifyPassword: "Tukar Kata Laluan",
        logout: "Log Keluar",
        "add": "Tambah",
        "edit": "Sunting",
        "delete": "Padam",
        "view": "Lihat",
        "menu_1": "Halaman Utama",
        "menu_2": "Pengurusan Peranti",
        "menu_3": "Sunting (Tetapan Lanjutan - Sunting Asas - Tukar Rangkaian)",
        "menu_4": "Arahan Segera",
        "menu_5": "Sunting (Pindah Jabatan)",
        "menu_6": "Strategi",
        "menu_7": "Tetapan Bunyi",
        "menu_8": "Tetapan Kecerahan",
        "menu_9": "Tetapan Muat Turun",
        "menu_10": "Tetapan Tidur",
        "menu_11": "Ciri-ciri Peranti",
        "menu_12": "Sunting/Tambah",
        "menu_13": "Pengurusan Program",
        "menu_14": "Sejarah Penerbitan",
        "menu_15": "Padam (Batch/Tunggal)",
        "menu_16": "Program Dalam Penerbitan",
        "menu_17": "Pengelompokan",
        "menu_19": "Senarai Program",
        "menu_20": "Sunting Kandungan",
        "menu_21": "Salin Program",
        "menu_23": "Terbitkan Program",
        "menu_24": "Pengurusan Bahan",
        "menu_25": "Muat Naik",
        "menu_28": "Penerbitan Cepat",
        "menu_29": "Pengurusan Templat",
        "menu_30": "Templat Awam",
        "menu_31": "Gunakan Sekarang",
        "menu_32": "Templat Saya",
        "menu_33": "Terbitkan ke Templat Awam",
        "menu_35": "Sejarah Perkongsian",
        "menu_36": "Pengurusan Audit",
        "menu_37": "Audit Program",
        "menu_38": "Audit (Lulus/Tolak)",
        "menu_39": "Audit Bahan",
        "menu_41": "Sejarah Audit (Pengendali)",
        "menu_42": "Sejarah Audit (Auditor)",
        "menu_43": "Lihat Bilangan Kelulusan",
        "menu_44": "Pengurusan Organisasi",
        "menu_45": "Pengurusan Log",
        "menu_46": "Log Pemutaran",
        "menu_47": "Log Penerbitan",
        "menu_48": "Log Ralat",
        "menu_49": "Log Operasi",
        "menu_50": "Log Fail",
        "menu_51": "Log Log Masuk",
        "menu_52": "Kelulusan Kandungan",
        "menu_53": "Ruang Simpanan",
        "menu_54": "Struktur Organisasi",
        "menu_55": "Kebenaran Peranan",
        "menu_56": "Pemberian Kuasa",
        "menu_57": "Lihat (Kebenaran Pemberian Kuasa)",
        "menu_58": "Ahli Organisasi",
        "menu_60": "Tetapkan Ulang Kata Laluan Pengguna Bawahan",
        "menu_61": "Pengurusan Aset",
        "menu_62": "Baki Saya",
        "menu_63": "Lihat (Butiran Kewangan)",
        "menu_64": "Penggunaan Data Saya",
        "menu_65": "Lihat (Butiran Penggunaan Data)",
        "menu_66": "Beli Penggunaan Data",
        "menu_67": "Kapasiti Saya",
        "menu_68": "Peranti Saya",
        "menu_69": "Butiran Pesanan",
        "menu_70": "Lihat (Isi Semula)",
        "menu_71": "Lihat (Templat yang Dibeli)",
        "menu_72": "Lihat (Penggunaan Data yang Dibeli)",
        "menu_73": "Kebenaran Lain",
        "menu_74": "Lihat (Statistik Bahan dan Program)",
        "menu_75": "Lihat (Aset)",
        "menu_76": "Lihat (Penggunaan Data Awan/Statistik)",
        "menu_77": "Lihat (Statistik Peranti Dalam Talian)"

    },
    login: {
        terminalServiceSystem: 'Sistem Perkhidmatan Terminal Pintar',
        accountLogin: 'Log Masuk Akaun',
        register: 'Daftar',
        accountLoginTip: 'Log masuk dengan akaun yang sudah wujud',
        scanQRCode: 'Sila imbas kod QR',
        readAndAgree: 'Saya telah membaca dan bersetuju',
        readAndAgreeLink: 'Perjanjian Perkhidmatan Pengguna',
        readAndAgreeAgreement: 'Sila baca dan bersetuju dengan Perjanjian Perkhidmatan Pengguna',
        forgetpassword: "Lupa kata laluan?",
        resetpassword: "Tetapkan Semula Kata Laluan",
        phoneEmptyTip: "Sila masukkan nombor telefon",
        nextStep: "Langkah Seterusnya",
        title: 'Selamat Datang Log Masuk',
        submit: 'Log Masuk',
        userName: 'Akaun',
        password: 'Kata Laluan',
        userNameEmptyTip: 'Sila masukkan akaun',
        passwordEmptyTip: 'Sila masukkan kata laluan',
        passwordFormatTip: 'Sila masukkan format kata laluan yang betul',
        passwordIsOk: 'Sila masukkan pengesahan kata laluan',
        passwordSign: 'Sila masukkan kata laluan',
        codeTip: "Sila masukkan kod pengesahan",
        phone: "Nombor telefon tidak boleh kosong",
        code: "Kod pengesahan tidak boleh kosong",
        nickname: "Nama syarikat tidak boleh kosong",
        pass: "Kata laluan tidak boleh kosong",
        pwdMessage: "Panjang kata laluan 8~20 aksara, tidak boleh mengandungi ruang kosong dan mestilah mengandungi 3 jenis daripada huruf besar, huruf kecil, nombor, dan aksara khas",
        pwdMessage01: "Sila masukkan kata laluan gabungan huruf dan nombor sekurang-kurangnya lapan digit",
        pwdMessage02: "Panjang kata laluan 8-20 aksara",
        pwdMessage03: "Kata laluan tidak boleh mengandungi ruang kosong",
        pwdMessage04: "Kata laluan mestilah mengandungi tiga daripada huruf besar, huruf kecil, nombor, dan simbol",
        newpassempty: "Kata laluan baru tidak boleh kosong",
        newpass: "Dua kali input kata laluan tidak konsisten",
        getcode: "Dapatkan Kod Pengesahan",
        format: "Format nombor telefon tidak betul",
        chongfa: "Hantar semula selepas saat",
        isSend: 'Telah dihantar',
        noregister: "Belum ada akaun? Daftar sekarang",
        Mobile: "Nombor Telefon",
        verificationcode: "Kod Pengesahan",
        petname: "Nama Panggilan",
        Quickregistration: "Pendaftaran Pantas",
        xiugaimima: "Tukar Kata Laluan",
        jiumima: "Kata Laluan Lama",
        xinmima: "Kata Laluan Baru",
        zaicishuruxinmima: "Masukkan Kata Laluan Baru Semula",
        xiugaichenggong: "Berjaya ditukar",
        xiugaishoujihao: "Tukar Nombor Telefon",
        dengluzhanghao: "Akaun Log Masuk",
        gongsiid: "ID Syarikat",
        yonghunicheng: "Nama Panggilan Pengguna",
        chuangjianshijian: "Masa Penciptaan",
        gongsimingcheng: "Nama Syarikat",
        denglumima: "Kata Laluan Log Masuk",
        jianyi: "Disyorkan menggunakan kata laluan gabungan huruf dan nombor",
        shezhimima: "Tetapkan Kata Laluan",
        shezhishoujihao: "Tukar/Tetapkan Nombor Telefon",
        yibangding: "Telah Dihubungkan",
        weibangding: "Belum Dihubungkan",
        zhanghuanquan: "Keselamatan Akaun",
        yonghuxinxi: "Maklumat Pengguna",
        zhuceSucMsg: 'Tahniah, pendaftaran berjaya!',
        verificationcodeSucMsg: "Kod pengesahan berjaya dihantar！",
        requiredIsEmpty: "Bidang wajib tidak boleh kosong！",
        emailObj: {
            title: 'E-mel',
            tit: 'Log Masuk E-mel',
            tip: 'Sila masukkan alamat e-mel',
            formatTip: 'Sila masukkan format e-mel yang betul',
        },
        phoneObj: {
            title: 'Nombor Telefon',
            tit: 'Log Masuk Telefon',
            tip: 'Sila masukkan nombor telefon',
            formatTip: 'Sila masukkan format nombor telefon yang betul',
        },
        emailOrPhoneObj: {
            title: 'E-mel atau Nombor Telefon',
            tit: 'Log Masuk E-mel atau Telefon',
            tip: 'Sila masukkan e-mel atau nombor telefon',
            formatTip: 'Sila masukkan format e-mel atau nombor telefon yang betul',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'Log Masuk WeChat',
        },
        googleObj: {
            title: 'Google',
            tit: 'Log Masuk Google',
        },
        confirm: 'Ya',
        confirmSubmit: 'Hantar Pengesahan',
        cancel: 'Batal',
        close: 'Tutup',
        bindSucMsg: 'Berjaya dihubungkan',
        toContinueBindAccount: 'Seterusnya untuk melengkapkan pengikatan akaun pihak ketiga',
        bindTip01: 'Tiada akaun? Daftar satu',
        bindTip02: 'Sudah ada akaun',
        bindTip03: 'Akaun pihak ketiga pada masa ini belum dihubungkan dengan akaun platform, sila hubungkan akaun yang sudah wujud atau daftar dan hubungkan akaun baru, supaya boleh log masuk dengan pantas pada masa hadapan.',
        bindTip04: 'Hubungkan akaun yang sudah wujud',
        bindTip05: 'Daftar dan hubungkan akaun baru',
        bindTip06: 'Anda telah diberi kebenaran melalui pihak ketiga, lengkapkan maklumat log masuk di bawah untuk melengkapkan pengikatan',
        bindSubmit: 'Hantar Pengikatan',
        enterAccountTip: 'Sila masukkan nama akaun',
        RegisterAndBind: 'Daftar dan Hubungkan',
        loginErr: 'Nama pengguna atau kata laluan salah！',
        usercenter: "Pusat Pengguna",
        pleaseInputName: "Sila masukkan nama",
        operationSuccess: "Operasi berjaya！",
        edit: "Edit",
        xiugai: "Tukar",
        userData: "Data Peribadi",
        changePassword: "Tukar Kata Laluan",
        account: "Akaun",
        userName01: "Nama Pengguna",
        phoneNumber: "Nombor Telefon",
        role: "Peranan",
        createTime: "Masa Penciptaan",
        genghuang: "Tukar",
        bangding: "Hubungkan",
        unbind: "Putus Hubungan",
        plesaseSelectBindingType: "Sila pilih jenis pengikatan",
        pleaseConfirmCont: "Sila sahkan bahawa saya telah membaca kandungan ini",
        confirmReadCont: "Saya telah membaca kandungan ini",
        frequentTip: "Operasi terlalu kerap, sila cuba lagi kemudian!",
        zhuxiaoBtn: "Padam Akaun",
        zhuxiaoTitle: "Pemadaman Akaun",
        querenZhuxiao: "Yakin Padam",
        jiXu: "Seterusnya",
        sendCodeBtn: "Hantar Kod Pengesahan",
        passwordIsNotOldPassword: "Pengesahan kata laluan berbeza dengan kata laluan baru yang dimasukkan",
        passwordIsOldPassword: "Kata laluan yang ditukar sama dengan kata laluan lama",
        passFormatError: "Sila masukkan format kata laluan yang betul",
        oldPassWord: "Kata Laluan Lama",
        newPassWord: "Kata Laluan Baru",
        inputPlaceholder: 'Sila masukkan',
        confirmPassword: "Pengesahan Kata Laluan",
        zhuxiaoTip: `
            1、Pemadaman akaun adalah operasi yang tidak boleh dipulihkan, selepas akaun dipadam, anda tidak boleh lagi log masuk dan menggunakan akaun ini atau akaun pihak ketiga yang didaftar dan log masuk melalui akaun ini, sila simpan salinan maklumat dan data berkaitan akaun secara sendiri.
            2、Sebelum mendaftar akaun ini, pastikan anda telah mengosongkan semua aset dan tiada sebarang perselisihan; selepas akaun ini dipadam, ia dianggap bahawa anda melepaskan hak pemilikan atas semua aset dan hak dalam akaun ini, dan tidak boleh dipulihkan atau dicari semula.
            3、Jika akaun yang didaftar dengan nombor telefon yang sama dipadam sehingga 3 kali secara kumulatif, nombor telefon tersebut tidak boleh mendaftar akaun baru lagi, dan juga tidak boleh dihubungkan ke mana-mana akaun lain.
            `
    },
    home: {
        title: "Laman Utama",
        quickOperation: "Operasi Pantas",
        addDevice: "Tambah Peranti",
        publishProgram: "Terbitkan Program",
        publishMaterial: "Terbitkan Bahan",
        makeProgram: "Buat Program",
        uploadMaterial: "Muat Naik Bahan",
        todayData: "Data Hari Ini (Dikemas kini setiap jam)",
        playNumChart: "Statistik Bilangan Permainan",
        deviceOnlineStatus: "Status Online Peranti",
        onLineDevice: "Peranti Online",
        unLineDevice: "Peranti Offline",
        programPlayTime: "Statistik Tempoh Permainan Program",
        downloadSoft: "Muat Turun Perisian",
        adminApp: "Aplikasi Pengguna Telefon Bimbit",
        playerApp: "Terminal Permainan Penerbitan Maklumat",
        downloadAdminApp: "Klik untuk muat turun aplikasi pengguna",
        downloadPlayerApp: "Klik untuk muat turun aplikasi pemain",
        aboutUs: "Tentang Kami",
        userManual: "Manual Pengguna",
        message: "Saya Ingin Menyerahkan Mesej",
    },
    device: {
        inputPlaceholder: 'Sila masukkan',
        selectPlaceholder: 'Sila pilih',
        osTypeStr: 'Sistem Terminal',
        onLineStatus: 'Status Online',
        dpi: 'Resolusi',
        companyDeptIdName: 'Institusi Berkaitan',
        deviceGroupIdName: 'Kumpulan Berkaitan',
        editOrMove: 'Edit/Pindahkan',
        loanOriginationFee: 'Yuran Pentadbiran Pinjaman',
        strategyInfoLook: 'Lihat Maklumat Strategi',
        programLook: 'Lihat Program',
        addEquipments: 'Tambah Peranti',
        luminanceSet: 'Kawal Kecerahan',
        terminal: 'Tetapan Terminal',
        transferCompany: 'Pindahkan Jabatan',
        releasedProgram: 'Terbitkan Program',
        screenshot: 'Tangkapan Skrin',
        changeGroup: 'Tukar Kumpulan',
        defaultGroup: "Kumpulan Lalai",
        operation: "Operasi",
        edit: "Edit",
        saveEdit: "Simpan Edit",
        add: "Tambah",
        save: "Simpan",
        setting: "Tetapan",
        program: "Program",
        unbind: "Putus Hubungan",
        sleep: "Mod Tidur",
        wakeup: "Bangunkan",
        restart: "Mulakan Semula",
        shutdown: "Matikan",
        reportLog: "Laporkan Log",
        clearPlayData: "Padam Data Terminal Permainan",
        offlineWarn: "Peranti ini sudah offline, sila cuba lagi selepas peranti online！",
        confirmUnbind: "Yakin untuk memutuskan hubungan",
        confirmReset: "Yakin untuk memadam",
        confirmDelete: "Yakin untuk memadam",
        delete: "Padam",
        cancelDelete: "Batal Padam",
        confirmResetSuccess: "Berjaya dipadam",
        confirm: "Ya",
        cancel: "Batal",
        operationSuccess: "Operasi Berjaya",
        unbindSuccess: "Berjaya Memutuskan Hubungan",
        pleaseSelectDevice: "Sila pilih peranti",
        pleaseSelectOnlineDevice: "Sila pilih peranti online",
        confirmMixOperation: "Peranti yang dipilih termasuk peranti offline, tetapan ini tidak sah untuk peranti offline, yakin meneruskan operasi？",
        pleaseSelectDate: "Sila pilih tarikh",
        reportSuccess: "Berjaya melaporkan",
        deviceSetting: "Tetapan Peranti",
        default: "Lalai",
        all: "Semua",
        deviceList: "Senarai Peranti",
        addDevice: "Tambah Peranti",
        department: "Jabatan Institusi",
        deviceType: "Resolusi",
        osType: "Sistem Terminal",
        onlineState: "Status Online",
        online: "Online",
        offline: "Offline",
        notActive: "Belum Diaktifkan",
        search: "Sila masukkan kata kunci",
        batchOperation: "Operasi Batch",
        allDevices: "Semua Peranti",
        deviceAttribute: "Atribut Peranti",
        selectReportDate: "Pilih Tarikh Pelaporan",
        inputName: "Sila masukkan nama",
        inputWidth: "Sila masukkan lebar",
        inputHeight: "Sila masukkan ketinggian",
        inputResolutionRatio: "Sila masukkan integer lebih besar daripada 0！",
        inputSort: "Sila masukkan susunan",
        serialNum: "Nombor Siri",
        name: "Nama",
        width: "Lebar",
        height: "Ketinggian",
        resolutionRatio: "Resolusi",
        inputResolutionRatioName: "Sila masukkan nama resolusi",
        sort: "Susun",
        personal: "Peribadi",
        system: "Sistem",
        type: "Jenis",
        systemDefaultSettingUneditable: "Tetapan lalai sistem tidak boleh diedit!",
        systemDefaultSettingUnDeletable: "Tetapan lalai sistem tidak boleh dipadam!",
        newz: "Tambah Baru",
        total: "Jumlah",
        totalNum: "baris",
        strategyName: "Nama Strategi",
        associatedTerminalNum: "Bilangan Terminal Berkaitan",
        createTime: "Masa Penciptaan",
        pleaseSelectStrategy: "Sila pilih strategi！",
        onlySelectOneData: "Hanya boleh memilih satu data！",
        downloadStrategy: "Muat Turun Strategi",
        inputStrategyName: "Sila masukkan nama strategi",
        luminanceControl: "Kawal Kecerahan",
        volumeStrategy: "Strategi Volum",
        saveSuccess: "Berjaya Disimpan",
        screenAngle: "Putaran Skrin(°)",
        startTime: "Masa Mulai",
        endTime: "Masa Tamat",
        repeat: "Ulangi",
        monday: "Isnin",
        tuesday: "Selasa",
        wednesday: "Rabu",
        thursday: "Khamis",
        friday: "Jumaat",
        saturday: "Sabtu",
        sunday: "Ahad",
        everyday: "Setiap Hari",
        downloadSpeed: "Kelajuan Muat Turun",
        inputDownloadSpeed: "Sila masukkan kelajuan muat turun",
        operator: "Operasi",
        pleaseSelectDeleteData: "Sila pilih data yang akan dipadam！",
        confirmBatchDelete: "Yakin memadam secara batch？",
        pleaseInputName: "Sila masukkan nama",
        detailSetting: "Tetapan Terperinci",
        weekPlan: "Rancangan Mingguan",
        specialDateSetting: "Tetapan Tarikh Khas",
        weekdayInfo: "Hari dalam minggu adalah pilihan wajib!",
        volumeInfo: "Volum adalah pilihan wajib!",
        timeError: "Ralat pemilihan masa!",
        editSuccess: "Operasi edit berjaya！",
        addSuccess: "Operasi tambah berjaya！",
        addSpecialPlan: "Tambah Rancangan Strategi Khas",
        downloadSpeedInfo: "Kelajuan muat turun:(0 bermakna melarang muat turun)",
        pleaseSelectStartTime: "Sila pilih masa mula",
        pleaseSelectEndTime: "Sila pilih masa tamat",
        luminanceError: "Sila masukkan nilai kecerahan yang betul！",
        defaultLuminance: "Kecerahan Lalai",
        luminance: "Saiz Kecerahan",
        defaultLuminanceInfo: "Kecerahan lalai(100 bermakna paling terang,0 bermakna paling gelap)",
        volume: "Volum",
        saveLuminance: "Simpan Kecerahan",
        changeSuccess: "Berjaya ditukar！",
        changeNetwork: "Tukar Rangkaian",
        netName: "Nama Rangkaian",
        nameempty: "Nama rangkaian tidak boleh kosong",
        currentNetwork: "Rangkaian Semasa",
        ipAddress: "Alamat IP",
        dailyMode: "Mod Setiap Hari",
        weeklyMode: "Mod Mingguan",
        turnOnTime: "Masa Hidupkan",
        turnOffTime: "Masa Matikan",
        startSleep: "Mulakan Mod Tidur",
        endSleep: "Tamat Mod Tidur",
        batchDelInfo: "Yakin memadam item yang dipilih？",
        timeCannotBeEmpty: "Masa tidak boleh kosong!",
        startUp: "Hidupkan",
        shutDown: "Matikan",
        volumeSize: "Saiz Volum",
        defaultVolume: "Volum Lalai(100 bermakna maksimum,0 bermakna bisu)",
        chooseStartTime: "Sila pilih masa mula",
        chooseEndTime: "Sila pilih masa tamat",
        saveVolume: "Simpan Volum",
        screenRotationUnSaved: "Putaran skrin belum disimpan",
        volumeSettingUnSaved: "Tetapan volum belum disimpan",
        luminanceSettingUnSaved: "Tetapan kecerahan belum disimpan",
        confirmClosePopup: "Yakin menutup popup ini?",
        volumeSettingSuccess: "Berjaya menukar volum",
        luminanceSettingSuccess: "Berjaya menukar kecerahan",
        advancedSettingUnSaved: "Tetapan lanjutan belum disimpan",
        settingTitle: "Tetapan Terminal",
        volumeSetting: "Tetapan Volum",
        luminanceSetting: "Tetapan Kecerahan",
        downloadSetting: "Tetapan Muat Turun",
        sleepSetting: "Tetapan Mod Tidur",
        onOffSetting: "Tetapan Hidup/Mati Tetap Masa",
        screenRotation: "Putaran Skrin",
        namingError: "Ralat penamaan, nama fail tidak boleh mengandungi ruang kosong！",
        deleteSuccess: "Berjaya dipadam",
        deleteFolder: "Padam Folder",
        pleaseInputDeviceName: "Sila masukkan nama peranti",
        pleaseInputDeviceId: "Sila masukkan ID peranti",
        discoverDevice: "Cari Peranti",
        deviceId: "ID Peranti",
        bound: "Telah Dihubungkan",
        bind: "Hubungkan",
        noDevice: "Tiada peranti",
        refresh: "Segarkan",
        manualAdd: "Tambah Manual",
        deviceGroup: "Pengelasan Peranti",
        pleaseSelectGroup: "Sila pilih kumpulan！",
        deviceName: "Nama Peranti",
        goAdd: "Pergi untuk menambah",
        close: "Tutup",
        bindCountInsufficient: "Bilangan yang boleh dihubungkan tidak mencukupi, sila tingkatkan bilangan peranti sebelum menambah！",
        displayNumber: "Nombor Paparan",
        groupName: "Nama Kumpulan",
        pleaseSelectGroupName: "Sila isi nama kumpulan！",
        moveGroup: "Pindahkan Kumpulan",
        longitude: "Longitud",
        latitude: "Latitud",
        nationality: "Kebangsaan",
        province: "Wilayah",
        city: "Bandar",
        county: "Daerah",
        outNetIp: "IP Rangkaian Luar",
        inNetIp: "IP Rangkaian Dalam",
        companyName: "Nama Syarikat",
        Info: "Terperinci",
        android: "Android",
        win: "Windows",
        osVersion: "Versi Sistem",
        softwareVersion: "Versi Perisian",
        diskSize: "Saiz Cakera",
        useSize: "Saiz Digunakan",
        macAddr: "Alamat MAC",
        longitudeLatitudeInfo: "Longitud dan latitud mesti kosong atau tidak kosong secara serentak!",
        terminalName: "Nama Terminal",
        terminalGroup: "Kumpulan Terminal",
        reportJournal: "Adakah melaporkan",
        systemVersion: "Versi Sistem",
        storageSpace: "Ruang Simpanan",
        resolution: "Resolusi",
        runningMemory: "Memori Aktif",
        model: "Model",
        registerStatus: "Status Pendaftaran",
        password: "Kata Laluan",
        passwordInfo: "Sila masukkan 6 hingga 18 huruf atau nombor!",
        group: "Kumpulan",
        address: "Alamat",
        remark: "Catatan",
        renewalPeriod: "Tempoh Pembaharuan",
        money: "Yuran",
        latitudeInfo: "Sila masukkan latitud yang betul!",
        totalPayment: "Jumlah Amaun",
        longitudeInfo: "Sila masukkan longitud yang betul!",
        setMeal: "Pakej",
        number: "Bilangan",
        programName: "Nama Program",
        playStatus: "Status Permainan",
        playType: "Cara Permainan",
        play: "Main",
        pause: "Jeda",
        playTime: "Masa Permainan",
        programDeleted: "Program telah dipadam",
        playSuccess: "Program telah diatur untuk dimainkan",
        pauseSuccess: "Berjaya dijeda",
        playCycle: "Main Semula",
        playInsert: "Sisip Permainan",
        withdrawSuccess: "Berjaya ditarik balik",
        withdrawInfo: "Sila pilih program yang akan ditarik balik terlebih dahulu！",
        programBelong: "Program Berkaitan",
        checkAll: "Pilih Semua",
        batchDel: "Padam Secara Batch",
        delConfirm: "Yakin memadam item yang dipilih？",
        check: "Dipilih",
        noProgram: "Tiada program",
        details: "Terperinci",
        screenshotFail: "Gagal mengambil tangkapan skrin",
        policyName: "Nama Dasar",
        terminalNum: "Bilangan Terminal Berkaitan",
        powerStrategy: "Strategi Kuasa",
        pleaseSelectDepartment: "Sila pilih jabatan！",
        screenshotControl: "Kawal Tangkapan Skrin",
        未激活: "Belum Diaktifkan",
        已激活: "Sudah Diaktifkan",
        未绑定: "Belum Dihubungkan",
        已绑定: "Sudah Dihubungkan",
    },
    programManage: {
        programList: "Senarai Program",
        publishProgram: "Jejak Penerbitan Program",
        week1: "Isnin",
        week2: "Selasa",
        week3: "Rabu",
        week4: "Khamis",
        week5: "Jumaat",
        week6: "Sabtu",
        week7: "Ahad",
        monday: "Hari Isnin",
        tuesday: "Hari Selasa",
        wednesday: "Hari Rabu",
        thursday: "Hari Khamis",
        friday: "Hari Jumaat",
        saturday: "Hari Sabtu",
        sunday: "Hari Ahad",
        name: "Nama",
        preview: "Pratinjau",
        playDeviceNum: "Bilangan Peranti Pemain",
        copyDeviceCode: "Klik untuk menyalin",
        osType: "Jenis Sistem",
        playDate: "Tarikh Permainan",
        playWeek: "Minggu Permainan",
        everyday: "Setiap Hari",
        start: "Mula",
        end: "Tamat",
        playOperateStatusStr: "Status Penerbitan",
        playDevice: "Peranti Pemain",
        downloadView: "Lihat Muat Turun",
        publisher: "Penerbit",
        publishTime: "Masa Penerbitan",
        operation: "Operasi",
        add: "Tambah",
        groupName: "Nama Kumpulan",
        selectDevice: "Pilih Terminal",
        searchDevice: "Cari Terminal",
        pleaseFillGroupName: "Sila isi nama kumpulan！",
        remarkInfo: "Catatan",
        compile: "Edit",
        withdrawConfirm: "Yakin menarik balik program ini？",
        confirm: "Ya",
        cancel: "Batal",
        withdraw: "Tarik Balik",
        batchWithdraw: "Tarik Balik Secara Batch",
        batchPublish: "Terbitkan Secara Batch",
        batchDelete: "Padam Secara Batch",
        batchOperation: "Operasi Batch",
        notUse: "Belum Digunakan",
        notChecked: "Belum Disemak",
        notPass: "Tidak Lulus",
        delete: "Padam",
        publishTextLeft: "Telah Diterbitkan",
        offTextLeft: "Telah Dijeda",
        pleaseSelectProgramToMove: "Sila pilih program yang akan dipindahkan！",
        pause: "Jeda",
        pauseConfirm: "Yakin untuk jeda？",
        play: "Main",
        downloadUdisk: "Muat Turun ke USB",
        deviceList: "Senarai Peranti",
        groupSelection: "Pemilihan Kumpulan",
        operationSuccess: "Operasi Berjaya",
        deleteSuccess: "Berjaya Dipadam",
        selectDate: "Pilih Tarikh",
        publishStatus: "Status Penerbitan",
        checkStatus: "Status Semakan",
        waitAuditing: "Menunggu Semakan",
        auditPass: "Semakan Lulus",
        auditRefuse: "Semakan Ditolak",
        all: "Semua",
        playStatus: "Sedang Dimainkan",
        playStatust: "Status Permainan",
        pauseStatus: "Telah Dijeda",
        notStartStatus: "Belum Bermula",
        resolutionratio: "Resolusi",
        totalNum: "baris",
        programName: "Nama Program",
        playStartTime: "Masa Mula Permainan",
        playEndTime: "Masa Tamat Permainan",
        createTime: "Masa Penciptaan",
        nationality: "Kebangsaan",
        province: "Wilayah",
        city: "Bandar",
        county: "Daerah",
        address: "Alamat",
        ip: "Alamat IP",
        location: "Lokasi",
        log: "Log",
        pleaseFillProgramName: "Sila isi nama program！",
        selectGroup: "Pilih Kumpulan",
        startTime: "Masa Mula",
        endTime: "Masa Tamat",
        publishCycle: "Kitaran Penerbitan",
        publishDeviceNum: "Bilangan Peranti Penerbitan",
        pleaseSelectRecord: "Sila pilih rekod",
        deviceName: "Nama Terminal",
        deviceId: "ID Peranti Terminal",
        deviceGroupIdName: "Kumpulan Lokasi",
        notClassified: "Belum Dikelaskan",
        osTypeStr: "Sistem Terminal",
        storageSpace: "Ruang Simpanan",
        onLineStatus: "Status Online",
        onLine: "Online",
        offLine: "Offline",
        sleep: "Mod Tidur",
        unknown: "Tidak Diketahui",
        registerStatus: "Status Pendaftaran",
        trialPeriod: "Tempoh Percubaan",
        notActive: "Belum Diaktifkan",
        active: "Sudah Diaktifkan",
        parameterError: "Parameter Salah!",
        pleaseSelectProgram: "Sila pilih program!",
        pleaseSelectProgramEdit: "Sila pilih program yang akan diedit!",
        confirmWithdrawSelectedProgram: "Yakin menarik balik program yang dipilih？",
        withdrawSuccess: "Berjaya Ditarik Balik",
        allPrograms: "Semua Program",
        defaultGroup: "Kumpulan Lalai",
        cannotShareEmptyProgram: "Tidak boleh berkongsi program kosong！",
        onlyShareYourProgram: "Hanya boleh berkongsi program yang Anda cipta!",
        pleaseSelectProgramEditPublishTime: "Sila pilih program yang telah diedit masa penerbitannya!",
        pleaseSelectDevice: "Sila pilih peranti!",
        programDetail: "Terperinci Program",
        errorReason: "Sebab Ralat",
        availableStorageSpaceInsufficient: "Ruang simpanan yang tersedia tidak mencukupi",
        partialDeviceReleaseFailure: "Penerbitan sebahagian peranti gagal",
        allDeviceReleaseSuccess: "Penerbitan semua peranti berjaya",
        partialDeviceReleaseSuccess: "Penerbitan sebahagian peranti berjaya",
        allGroup: "Semua Kumpulan",
        allProgram: "Semua Program",
        unGrouped: "Belum Berkumpulan",
        replaceProgram: "Ganti Program",
        replaceProgramTip: "Program yang baru diterbitkan akan menggantikan data program yang telah dihantar ke terminal pemain sebelum ini！",
        screen: "Skrin Tunggal/Ganda",
        singleScreen: "Skrin Tunggal",
        doubleScreen: "Skrin Ganda",
        playSetting: "Tetapan Permainan",
        batchPlaySetting: "Tetapkan Masa Permainan Secara Batch",
        individualPlaySetting: "Tetapkan Masa Permainan Secara Individual",
        playTime: "Masa Permainan",
        daily: "Setiap Hari",
        weekdays: "Isnin hingga Jumaat",
        monthly: "Bulan Ini",
        advancedSetting: "Tetapan Lanjutan",
        playProgram: "Main Program",
        searchProgram: "Sila masukkan kata kunci",
        shareAddressNotExist: "Alamat pautan tidak wujud, sila cuba lagi",
        copySuccess: "Berjaya Disalin",
        shareLink: "Pautan Berkongsi",
        publish: "Terbitkan",
        noResource: "Tiada Sumber Daya",
        single: "Skrin Tunggal",
        double: "Skrin Ganda",
        time: "Masa",
        associatedTerminalNum: "Bilangan Terminal Berkaitan",
        default: "Lalai",
        moveGroup: "Pindahkan Kumpulan",
        pleaseSelectGroup: "Sila isi nama kumpulan！",
        copy: "Salin",
        FUBEN: "Salinan",
        nameempty: "Nama tidak boleh kosong",
        whitespace: "Ralat penamaan, nama fail tidak boleh mengandungi ruang kosong！",
        programWhitespace: "Ralat penamaan, nama program tidak boleh mengandungi ruang kosong！",
        pleaseSelectResolution: "Sila pilih resolusi！",
        dataError: "Data Salah！",
        createProgram: "Buat Program Baru",
        directCreate: "Buat Langsung",
        myTemplate: "Templat Saya",
        use: "Gunakan",
        free: "Percuma",
        loadMore: "Muat Lebih Banyak",
        confirmDelete: "Yakin Padam",
        deleteGroup: "Padam Kumpulan",
        notPublished: "Belum Diterbitkan",
        notPassed: "Tidak Lulus",
        notUsed: "Belum Digunakan",
        confirmDeleteSelectedProgram: "Yakin memadam program yang dipilih？",
        companyName: "Nama Syarikat",
        programCannotDownload: "Program ini tidak boleh dimuat turun！",
        publishMaterial: "Terbitkan Bahan",
        playMaterial: "Main Bahan",
        pleaseInputMaterialName: "Sila masukkan nama bahan",
        size: "Saiz",
        pleaseInputDeviceName: "Sila masukkan nama peranti",
        item: "baris",
        allMaterial: "Semua Bahan",
        allDevices: "Semua Peranti",
        "saveSuccess": "Disimpan dengan berjaya",
        "savefaill": "Gagal disimpan",
        "playMode": "Mod main",
        "cyclePlay": "Main berulang",
        "insertPlay": "Main sisipan",
        "noData": "Tiada data",
        "Add": "Tambah baharu",
        "replace": "Gantikan",
        "repeat": "Ulang",
        "start01": "Mula",
        "end01": "Akhir",
        "startDate": "Tarikh mula",
        "endDate": "Tarikh akhir",
        "useNow": "Gunakan segera",
        "fillStartEndTimeFirst": "Sila isi masa mula dan akhir terlebih dahulu sebelum menambah",
        "fillFullPlayTime": "Sila isi tempoh main yang lengkap",
        "fillCorrectPlayTime": "Sila isi tempoh main yang betul",
        "sDateAndEDateBothEmptyOrFilled": "Tarikh mula dan tarikh akhir mestilah kedua-duanya kosong atau kedua-duanya diisi"
    },
    source: {
        addResource: "Tambah Sumber Daya",
        width: "Lebar",
        height: "Ketinggian",
        size: "Saiz(KB)",
        name: "Nama",
        pleaseInputResourceName: "Sila masukkan nama sumber daya！",
        addToGroup: "Tambahkan ke Kumpulan",
        remark: "Catatan",
        promptFgIllustrate: "Ilustrasi",
        promptFgRealisticPhoto: "Foto Realistik",
        promptFgSimplisticDrawing: "Gambar Ringkas",
        promptFgChineseStyle: "Gaya Cina",
        promptFgPixelArt: "Seni Piksel",
        noModel: "Tiada model, sila hubungi pentadbir！",
        getModelFailed: "Gagal mendapatkan model, sila cuba lagi kemudian！Atau hubungi pentadbir！",
        createImagePrompt: "Sedang membuat gambar, sila tutup kemudian！",
        promptEmpty: "Sila masukkan petunjuk",
        dpiEmpty: "Sila pilih nisbah gambar！",
        fgEmpty: "Sila pilih gaya！",
        style: "Gaya",
        idEmpty: "ID gambar tidak boleh kosong",
        exist: "Gambar ini sudah wujud dalam bahan",
        addSuccess: "Berjaya menambah bahan",
        saveError: "Gagal menyimpan gambar, sila cuba lagi kemudian！",
        delSuccess: "Berjaya dipadam",
        generateImage: "Teks ke Gambar",
        generateImagePlaceholder: 'Sila masukkan gambar yang ingin Anda buat, contoh: Seekor rama-rama menari di tengah padang bunga',
        aiExpand: "Pembesaran Pintar AI",
        negativePrompt: "Petunjuk Negatif",
        negativePromptTooltip: "Digunakan untuk secara eksplisit mengecualikan kandungan atau ciri yang tidak ingin muncul dalam output pengguna",
        imageRatio: "Nisbah Gambar",
        generateImageBtn: "Cipta Sekarang",
        shengchengjieguo: "Hasil Penciptaan",
        generateImageLoadingTip: "Sedang dicipta, jangan klik semula atau tutup...",
        Tooltip: "Mari wujudkan kreativiti anda dengan AI",
        saveToMaterial: "Simpan ke Bahan",
        publish: "Terbitkan Sekarang",
        download: "Muat Turun",
        generateHistory: "Sejarah Penciptaan",
        hide: "Sembunyikan",
        cancel: "Batal",
        useExpand: "Gunakan Pembesaran",
        all: "Semua",
        delete: "Padam",
        loadMore: "Muat Lebih Banyak",
        aiTip: "Kandungan dicipta oleh model kecerdasan buatan, tidak mewakili pandangan, kedudukan atau sikap platform, sila gunakan kandungan AI dengan wajar dan mengikut peraturan",
        operationSuccess: "Operasi Berjaya",
        moveGroup: "Pindahkan Kumpulan",
        groupName: "Nama Kumpulan",
        pleaseSelectGroup: "Sila pilih nama kumpulan！",
        shenhe: "Semakan",
        shenheStatus: "Status Semakan",
        shenheSuccess: "Semakan Lulus",
        shenheRefuse: "Semakan Ditolak",
        pleaseSelectShenheStatus: "Sila pilih status semakan！",
        shenheRemark: "Catatan Semakan",
        pleaseInputShenheRemark: "Sila masukkan catatan semakan！",
        pleaseInputFileName: "Sila masukkan nama fail！",
        whitespace: "Ralat penamaan, nama fail tidak boleh mengandungi ruang kosong！",
        dataError: "Data Salah！",
        confirmDelete: "Yakin Padam",
        confirm: "Ya",
        deleteFolder: "Padam Folder",
        add: "Tambah",
        edit: "Edit",
        fileName: "Nama Fail",
        group: "Kumpulan",
        resolution: "Resolusi",
        type: "Jenis",
        image: "Gambar",
        music: "Muzik",
        video: "Video",
        uploadTime: "Masa Muat Naik",
        uploadUser: "Pengunggah",
        checkTime: "Masa Semakan",
        checkUser: "Pemeriksa",
    },
    setting: {
        nameempty: "Nama tidak boleh kosong",
        heightempty: "Ketinggian tidak boleh kosong",
        widthempty: "Lebar tidak boleh kosong",
        resolutionratio: "Resolusi",
        name: "Nama",
        opteration: "Operasi",
        compile: "Edit",
        delete: "Padam",
        newz: "Tambah Baru",
        compileratio: "Edit Resolusi",
        sheizhifenbianlvmingcheng: "Tetapkan Nama Resolusi",
        shezhigaodu: "Tetapkan Ketinggian",
        shezhikuandu: "Tetapkan Lebar",
        xinzengfenbianlv: "Tambah Resolusi Baru",
        bianma: "Kod",
        bianjizhongduanmingcheng: "Edit Nama Terminal",
        xinzengzhongduan: "Tambah Terminal Baru",
        selectPrimaryColor: 'Pilih Warna Tema',
        fullScreen: 'Skrin Penuh',
        exitFullScreen: 'Keluar dari Skrin Penuh',
    },
    tabs: {
        refresh: 'Segarkan',
        refreshAll: 'Segarkan Semua',
        close: 'Tutup',
        closeOthers: 'Tutup Yang Lain',
        closeAll: 'Tutup Semua',
        closeLeft: 'Tutup Kiri',
        closeRight: 'Tutup Kanan',
    },
    errorPage: {
        needLogin: 'Anda belum log masuk！',
        pageNotFound: 'Halaman yang anda akses tidak wujud！',
        redirectTo: 'Dialihkan ke',
        orReturn: 'Atau kembali ke',
        previousStep: 'Langkah Sebelumnya',
    },
    headerUs: {
        systemNotice: "Notis Sistem",
        allNotices: "Semua Notis",
        viewAllMessages: "Lihat Semua Mesej",
        contactUs: "Hubungi Kami",
        operationSuccess: "Operasi berjaya！",
        leaveMessage: "Saya Ingin Menyerahkan Mesej",
        messageTitle: "Tajuk",
        messageTitleTip: "Sila masukkan tajuk！",
        messageContentTip: "Tidak lebih daripada 150 perkataan",
        submit: "Hantar",
        markAsRead: "Tandakan sebagai Dibaca",
        success: "Operasi berjaya！"
    },
    material: {
        allMaterial: "Semua Bahan",
        defaultGroup: "Kumpulan Lalai",
        auditStatus: "Status Semakan",
        auditPassed: "Semakan Lulus",
        auditRejected: "Semakan Ditolak",
        pendingAudit: "Menunggu Semakan",
        all: "Semua",
        operateSuccess: "Operasi berjaya！",
        pleaseSelectMaterial: "Sila pilih bahan！",
        moveGroup: "Pindahkan Kumpulan",
        pleaseSelectGroup: "Sila pilih kumpulan！",
        batchPublish: "Terbitkan Secara Batch",
        batchRecall: "Panggil Balik Secara Batch",
        batchDelete: "Padam Secara Batch",
        materialList: "Senarai Bahan",
        uploadMaterial: "Muat Naik Bahan",
        materialType: "Jenis Bahan",
        pleaseInputMaterialName: "Sila masukkan nama bahan",
        selectAll: "Pilih Semua",
        confirmDeleteSelectedMaterial: "Yakin memadam bahan yang dipilih？",
        deleteSuccess: "Berjaya Dipadam",
        delete: "Padam",
        publish: "Terbitkan",
        recall: "Panggil Balik",
        confirmRecallSelectedMaterial: "Yakin memanggil balik bahan yang dipilih？",
        pleaseSelectMaterialGroup: "Sila pilih kumpulan bahan！",
        recallSuccess: "Berjaya Dipanggil Balik",
        publishSuccess: "Berjaya Diterbitkan",
        batchOperate: "Operasi Batch",
        item: "baris",
        confirmDelete: "Yakin Padam？",
        edit: "Edit",
        confirmRecall: "Yakin Panggil Balik？",
        unaudited: "Belum Disemak",
        notPassed: "Tidak Lulus",
        operate: "Operasi",
        resolution: "Resolusi",
        none: "Tiada",
        confirm: 'Ya',
        cancel: 'Batal',
        AICreation: "Kreativiti AI",
    },
    uploadFile: {
        operationSuccess: "Operasi Berjaya",
        uploadFile: "Pengurusan Muat Naik",
        uploadSuccess: "Berjaya Muat Naik",
        uploadCompleted: "Muat Naik Selesai",
        uploadFail: "Gagal Muat Naik",
        ConversionFailed: "Penukaran Gagal！",
        loading: "Sedang memuat...",
        beQueuing: "Dalam Barisan Menunggu...",
        Uploading: "Mengunggah...",
        ConversionIng: "Menukar...",
        ConventionalResources: "Sumber Daya Konvensional",
        DocumentResources: "Sumber Daya Dokumen",
        complete: "Selesai",
        upload: "Muat Naik",
        fileSizeWraning01: "Saiz bahan melebihi",
        fileSizeWraning02: "Sila ubah dan muat naik semula！",
        fileIsEmpty: "Fail kosong",
        uploadFileTip: "Format fail tidak disokong",
        unablePreview: "Tidak berjaya ditambahkan ke perpustakaan bahan, tidak boleh dipratinjau",
        confirmDelete: "Yakin Padam？",
        deleteSuccess: "Berjaya Dipadam",
        delete: "Padam",
        confirm: "Ya",
        preview: "Pratinjau",
        close: "Tutup",
        cancel: "Batal",
        fileType: "Jenis Fail",
        fileSize: "Saiz Fail",
        conversionProgress: "Kemajuan Penukaran",
        progress: "Kemajuan",
        image: "Gambar",
        video: "Video",
        audio: "Muzik",
        limitTip01: "Muat naik sekali",
        limitTip02: "fail",
        okTip: "Sedang mengunggah bahan, sila tutup kemudian！",
        usableSize: 'Kapasiti Tersedia',
        sizeUnableTip: "Ruang simpanan yang tersedia pada masa ini tidak mencukupi, sila bersihkan bahan yang tidak berguna secara tetap untuk menjimatkan ruang atau hubungi pengedaran untuk mengembangkan kapasiti ruang simpanan awan. Perkhidmatan ini mungkin mendatangkan kos, sila rujuk maklumat pengedar untuk butiran.",
        view: "Lihat Terperinci",
        fileName: "Nama Fail",
    },
    template: {
        inputPlaceholder: 'Sila masukkan',
        selectPlaceholder: 'Sila pilih',
        noAuths: "Tiada kebenaran, sila hubungi pentadbir",
        operationSuccess: "Operasi Berjaya",
        total: "Jumlah",
        totalNum: "baris",
        dan: "Tunggal",
        shaung: "Ganda",
        pleaseSelectGroup: "Sila pilih kumpulan",
        preview: "Pratinjau",
        free: "Percuma",
        use: "Gunakan",
        dpi: 'Resolusi',
        delete: "Padam",
        confirmDelete: "Yakin Padam",
        confirmDeleteSelectedTemplate: "Yakin memadam templat ini",
        push: "Terbitkan",
        pushConfirm: "Yakin menerbitkan ke templat awam",
        pushRemovalConfirm: "Yakin menarik balik dari templat awam",
        templateOrderRecord: "Rekod Pesanan Templat",
        unpublished: "Belum Diterbitkan",
        auditing: "Dalam Semakan",
        publishRejected: "Penerbitan Ditolak",
        publishSuccess: "Berjaya Diterbitkan",
        offShelf: "Tarik Balik dari Pasaran",
        公共模版: "Templat Awam",
        我的模板: "Templat Saya",
        共享记录: "Rekod Berkongsi",
        name: "Nama",
        pubdate: "Masa Penerbitan",
        keySeachTip: "Sila masukkan kata kunci",
        allGroup: "Semua Kumpulan",
        add: "Tambah",
        edit: "Edit",
        programName: "Nama Program",
        selectGroup: "Pilih Kumpulan",
    },
    checkManage: {
        total: "Jumlah",
        totalNum: "baris",
        operationSuccess: "Operasi Berjaya",
        checkUserLogs: "Rekod Semakan (Operator)",
        checkLogs: "Rekod Semakan (Pemeriksa)",
        sourceCheck: "Semakan Bahan",
        programCheck: "Semakan Program",
        checkAll: "Pilih Semua",
        auditPass: "Semakan Lulus",
        auditRefuse: "Semakan Ditolak",
        auditPass01: "Lulus",
        auditRefuse01: "Ditolak",
        auditRefuse02: "Tolak Semakan",
        auditor: "Pemeriksa",
        agentUserName: "Penerbit",
        interrogationTime: "Masa Pengemudian Semakan",
        checkTime: "Masa Semakan",
        checkName: "Nama Semakan",
        checkType: "Kategori Semakan",
        checkIp: "Alamat IP Pengemudian Semakan",
        checkReason: "Mesej",
        checkStatus: "Kandungan Operasi",
        rangePicker: "Tarikh Semakan",
        keyWord: "Kata Kunci",
        all: "Semua",
        program: 'Program',
        material: 'Bahan',
        dan: "Tunggal",
        shaung: "Ganda",
        pleaseSelectProgram: "Sila pilih program!",
        pleaseSelectMaterial: "Sila pilih bahan！",
        preview: "Pratinjau",
        dpi: 'Resolusi',
        auditRefuseTip: "Sila masukkan sebab penolakan",
        unreviewed: "Belum Disemak",
        notPassed: "Tidak Lulus",
        notUsed: "Belum Digunakan",
        edit: "Edit",
        none: "Tiada",
        name: "Nama",
        size: "Saiz",
        type: "Jenis",
        uploadTime: "Masa Muat Naik",
        uploadUser: "Pengunggah",
        checkUser: "Pemeriksa",
        image: "Gambar",
        music: "Muzik",
        video: "Video",
    },
    systemSet: {
        total: "Jumlah",
        totalNum: "baris",
        inputPlaceholder: 'Sila masukkan',
        selectPlaceholder: 'Sila pilih',
        userList: "Ahli Organisasi",
        roleList: "Kebenaran Peranan",
        department: "Arsitektur Organisasi",
        diskInfo: "Ruang Simpanan",
        approveSet: "Kelulusan Kandungan",
        logList: "Pengurusan Log",
        name: "Nama",
        account: "Akaun",
        userName: "Nama Pengguna",
        phoneNumber: "Nombor Telefon",
        role: "Peranan",
        createTime: "Masa Penciptaan",
        operation: "Operasi",
        edit: "Edit",
        delete: "Padam",
        addNew: "Tambah Baru",
        add: "Tambah",
        resetPassword: "Tetapkan Semula Kata Laluan",
        confirmDelete: "Yakin Padam",
        departmentOrganization: "Jabatan Institusi",
        addNewUser: "Tambah Pengguna Baru",
        pleaseEnterUserName: "Sila masukkan nama pengguna",
        confirmPasswordNotMatch: "Pengesahan kata laluan tidak sepadan dengan kata laluan yang dimasukkan!",
        operationSuccess: "Operasi berjaya！",
        userNickname: "Nama Pengguna",
        pleaseEnterUserNickname: "Sila masukkan nama pengguna",
        userNicknameRequired: "Nama pengguna tidak boleh kosong！",
        password: "Kata Laluan",
        pleaseEnterPassword: "Sila masukkan kata laluan",
        passwordRequired: "Kata laluan tidak boleh kosong！",
        passwordTip: "Keselamatan kata laluan anda terlalu rendah (kata laluan mestilah mengandungi mana-mana 3 jenis daripada huruf besar, huruf kecil, nombor, dan simbol khas dan panjangnya antara 8",
        confirmPassword: "Pengesahan Kata Laluan",
        pleaseEnterPhoneNumber: "Sila masukkan nombor telefon",
        phoneNumberRequired: "Nombor telefon tidak boleh kosong！",
        phoneNumberFormatError: "Sila masukkan nombor telefon yang betul！",
        roleRequired: "Peranan tidak boleh kosong！",
        required: "Tidak boleh kosong！",
        departmentName: "Jabatan",
        modifyPassword: "Tukar Kata Laluan",
        newPassword: "Kata Laluan Baru",
        pleaseEnterNewPassword: "Sila masukkan kata laluan baru",
        pwdMessage: "Panjang kata laluan 8~20 aksara, tidak boleh mengandungi ruang kosong dan mestilah mengandungi 3 jenis daripada huruf besar, huruf kecil, nombor, dan aksara khas",
        all: "Semua",
        noAuths: "Tiada kebenaran, sila hubungi pentadbir",
        departmentName01: "Nama Jabatan",
        image: "Gambar",
        music: "Muzik",
        video: "Video",
        buySize: "Bilangan Pembelian",
        totalMoney: "Amaun Bayaran",
        buycreateTime: "Masa Pembelian",
        endTime: "Masa Tamat Tempoh",
        buyTypeStr: "Jenis Pesanan",
        sourceCheck: "Semakan Bahan",
        programCheck: "Semakan Program",
        programName: "Nama Program",
        diskExpansion: "Disyorkan untuk membersihkan bahan yang tamat tempoh/tidak digunakan semasa penggunaan untuk memastikan kapasiti yang tersedia untuk sistem. Jika anda memerlukan ruang yang lebih besar, anda boleh menghubungi pembekal peranti anda untuk mendapatkan perkhidmatan pengembangan kapasiti ruang simpanan awan. Perkhidmatan ini mungkin mendatangkan kos, sila rujuk maklumat pengedar untuk butiran.",
        selectPermission: "Sila pilih kebenaran",
        checkPermission: "Sila tandakan kebenaran",
        addRole: "Tambah Peranan",
        enterRoleName: "Sila masukkan nama peranan",
        roleName: "Nama Peranan",
        roleNameRequired: "Nama peranan tidak boleh kosong！",
        remark: "Catatan",
        enterRemark: "Sila masukkan catatan",
        permissionSetting: "Tetapan Kebenaran",
        deleteSuccess: "Berjaya dipadam！",
        confirmToDelete: "Yakin padam？",
        orgName: "Nama Institusi",
        orgNameRequired: "Nama institusi tidak boleh kosong！",
        orgRemark: "Catatan Institusi",
        enterOrgRemark: "Sila masukkan catatan institusi",
        capacityUsage: "Status Penggunaan Kapasiti",
        usedCapacity: "Kapasiti Digunakan",
        totalCapacity: "Jumlah Kapasiti",
        remainingCapacity: "Kapasiti Baki",
        capacityExpansion: "Pengembangan Kapasiti",
        enable: "Aktifkan",
        disable: "Nyahaktifkan",
        userName01: "Nama Pengguna",
        loginTime: "Masa Log Masuk",
        ipAddress: "Alamat IP",
        loginResult: "Hasil Log Masuk",
        selectDate: "Pilih Tarikh",
        enterDate: "Sila pilih tarikh",
        selectStartTime: "Sila pilih masa mula",
        selectEndTime: "Sila pilih masa tamat",
        enterUserName: "Sila masukkan nama pengguna",
        userCount: "Bilangan Pengguna",
        roleDesc: "Penerangan Peranan",
        roleAuthorization: "Pemberian Kebenaran Peranan",
        success: "Berjaya",
        failure: "Gagal",
        time: "Masa",
        operationContent: "Kandungan Operasi",
        playCount: "Bilangan Permainan",
        playDuration: "Tempoh Permainan",
        selectDevice: "Pilih Peranti",
        enterProgramName: "Sila masukkan nama program",
        serialNumber: "Nombor Siri",
        publishContentName: "Nama Kandungan Penerbitan",
        playMode: "Cara Permainan",
        cyclePlay: "Main Semula",
        insertPlay: "Sisip Permainan",
        paddingPlay: "Pad Permainan",
        playDeviceId: "ID Peranti Pemain",
        playDeviceName: "Nama Peranti Pemain",
        publishTime: "Masa Penerbitan",
        downloadStatus: "Status Muat Turun",
        notDownloaded: "Belum Dimuat Turun",
        downloading: "Sedang Dimuat Turun",
        downloadSucceeded: "Berjaya Dimuat Turun",
        downloadFailed: "Gagal Dimuat Turun",
        enterPublishContentName: "Sila masukkan nama kandungan penerbitan",
        terminalId: "ID Terminal",
        belongOrg: "Institusi Berkaitan",
        reportTime: "Masa Pelaporan",
        reportIp: "IP Pelaporan",
        logInfo: "Maklumat Log",
        details: "Terperinci",
        confirmDeletion: "Yakin untuk memadam？",
        logDetails: "Terperinci Log",
        download: "Muat Turun",
        deptOrg: "Jabatan Institusi",
        query: "Carian",
        queryByTerminalId: "Cari mengikut ID Terminal",
        batchDeleteLogs: "Padam Log Secara Batch",
        customTimeDeleteLogs: "Padam Log mengikut Masa Tetapan Sendiri",
        selectTimeRangeFirst: "Sila pilih julat masa terlebih dahulu",
        deleteAllDeviceLogsIfEmpty: "Jika ID peranti tidak diisi, secara lalai akan memadam log semua peranti",
        enterDeviceIdToDeleteLogs: "Sila masukkan ID peranti untuk memadam log",
        confirmDeleteAction: "Yakin Padam",
        selectDeleteRangeFirst: "Sila pilih julat pemadaman terlebih dahulu",
        networkConnectionFailed: "Gagal menyambung rangkaian",
        playLog: "Log Permainan",
        publishLog: "Log Penerbitan",
        errorLog: "Log Ralat",
        operationLog: "Log Operasi",
        fileLog: "Log Fail",
        userOperateLog: "Log Log Masuk",
    },
    userManual: {
        userManual: "Manual Pengguna",
        noData: "Tiada Data",
    },
    systemNotice: {
        systemNotice: "Notis Sistem",
        noData: "Tiada Data",
        total: "Jumlah",
        totalNum: "baris",
        "markAllRead": "Semua Sudah Dibaca",
        "deleteAll": "Padam Semua",
        "all": "Semua",
        "unread": "Belum Dibaca",
        "read": "Sudah Dibaca",
        "type": "Jenis",
        "content": "Kandungan",
        "date": "Tarikh",
        "status": "Status",
        "confirmDelete": "Yakin Padam？",
        "confirm": "Ya",
        "cancel": "Batal",
        "delete": "Padam"
    }
};